import { Grid, InputAdornment, TextField } from "@material-ui/core";
import React, { PropsWithChildren } from "react";
import { Link } from "react-router-dom";
import { routes } from "../../../routes";
import { useOfflineAssets } from "../../offline/useOfflineAssets";
import { AddNewButton } from "../AddNew/AddNewButton";
import { LibraryView, useLibrary, useLibrarySearch } from "../LibraryPage";
import { SideNavigation } from "../SideBar/SideNavigation";
import CloseIcon from "@material-ui/icons/Close";
import SearchIcon from "@material-ui/icons/Search";
import { UserAvatar } from "../../../components/UserAvatar";
import { GridGrow } from "../../../components/GridGrow";

export function DesktopLibraryLayout(props: PropsWithChildren<{}>) {
	const { onlineMode } = useOfflineAssets();
	const context = useLibrary();
	const searchContext = useLibrarySearch();
	const { activeView } = context;

	const getSearchPlaceHolder = () => {
		switch (activeView) {
			case LibraryView.SermonTemplateList:
				return "Search Sermon Templates";
			case LibraryView.PremiumSermonDetail:
			case LibraryView.PremiumSermonList:
				return "Search Premium Sermons";
			case LibraryView.PremiumSermonSeriesDetail:
			case LibraryView.PremiumSermonSeriesList:
				return "Search Premium Series";
			default:
				return "Search Library";
		}
	};

	return (
		<div id="library-desktop-layout">
			<div
				id="library-desktop-layout-sidebar"
				style={{
					top: 0,
					bottom: 0,
					width: 240,
					position: "absolute",
					overflowX: "hidden",
					whiteSpace: "nowrap",
				}}
			>
				<div style={{ overflowY: "auto" }}>
					<Link to={onlineMode ? routes.app.libraryHomePage : routes.app.libraryOfflinePage} style={{ textDecoration: "none" }}>
						<img style={{ display: "block", width: "100%", padding: 20 }} src="//i.cdn-sc.com/Logos/sm-horiz300.png" alt="Sermon Maker" />
					</Link>
					<AddNewButton />
					<SideNavigation />
				</div>
			</div>
			<div
				id="library-desktop-layout-header"
				style={{
					position: "absolute",
					top: 0,
					left: 240,
					right: 0,
					height: 64,
				}}
			>
				<Grid container alignItems="center" style={{ height: 64, paddingLeft: 20, paddingRight: 20 }}>
					<Grid item>
						<TextField
							variant="outlined"
							placeholder={getSearchPlaceHolder()}
							style={{
								width: 500,
								backgroundColor: "#F5F5F5",
								borderRadius: 5,
							}}
							value={searchContext.searchValue}
							autoFocus={activeView === LibraryView.Search ? true : false}
							onChange={(e) => searchContext.setSearchValue(e.currentTarget.value)}
							disabled={!onlineMode}
							inputProps={{ style: { padding: 14 } }}
							InputProps={{
								startAdornment: (
									<InputAdornment position="start">
										<SearchIcon />
									</InputAdornment>
								),
								endAdornment: searchContext.searchValue && (
									<InputAdornment position="end" style={{ cursor: "pointer" }}>
										<CloseIcon onClick={() => searchContext.setSearchValue("")} />
									</InputAdornment>
								),
							}}
						/>
					</Grid>
					<GridGrow />
					<Grid item>
						<UserAvatar />
					</Grid>
				</Grid>
			</div>
			<div
				id="library-desktop-layout-view"
				style={{
					top: 64,
					bottom: 0,
					right: 0,
					left: 240,
					paddingLeft: 20,
					position: "absolute",
					overflowY: "hidden",
					overflowX: "hidden",
				}}
			>
				{props.children}
			</div>
		</div>
	);
}
